import './index.css'

const SkillsSection = props => {
  const {skills} = props
  return (
    <>
      <h1 className="skills-heading">Skills</h1>
      <ul className="skills-container">
        {skills.map(eachSkill => (
          <li className="skill-item" key={eachSkill.name}>
            <img
              src={eachSkill.imageUrl}
              alt={eachSkill.name}
              className="skill-img"
            />
            <p>{eachSkill.name}</p>
          </li>
        ))}
      </ul>
    </>
  )
}

export default SkillsSection
